import { createSelector } from 'reselect'

import { selectPartnerSearchState } from './selectPartnerSearchState'

export const selectHighlightedWords = createSelector(
  [selectPartnerSearchState],
  ({ highlightedWords }) => highlightedWords
)
